
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class QueueDialog extends SiteEntityDialog<QueueRow, any> {
        protected getFormKey() { return QueueForm.formKey; }
        protected getIdProperty() { return QueueRow.idProperty; }
        protected getLocalTextPrefix() { return QueueRow.localTextPrefix; }
        protected getNameProperty() { return QueueRow.nameProperty; }
        protected getService() { return QueueService.baseUrl; }

        protected form = new QueueForm(this.idPrefix);

        constructor() {
            super();

            this.form.QueueTypeCode.changeSelect2(() => {
                this.updateInterface();
            });
        }

        protected updateInterface() {
            super.updateInterface();

            var isApproval = this.form.QueueTypeCode.value == "APPROVAL";
            var isCustom = this.form.QueueTypeCode.value == "CUSTOM";
            this.form.FieldList.getGridField().toggle(isCustom);
            this.form.WorkflowCode.getGridField().toggle(isCustom);
            this.form.StatusCodes.getGridField().toggle(isCustom);
            this.form.ApprovePermission.getGridField().toggle(isApproval);
            this.form.RejectPermission.getGridField().toggle(isApproval);
            this.form.SkipPermission.getGridField().toggle(isApproval);
            this.form.ViewPermission.getGridField().toggle(isCustom || isApproval);
            var tabLinks = this.propertyGrid.element.find('.property-tabs').eq(0).children('li').children('a');
            var tabItemOf = (w: Serenity.Widget<any>) => tabLinks.filter('[href="#' + w.getGridField().closest('.tab-pane').attr('id') + '"]').parent('li');
            tabItemOf(this.form.WorkflowClass1).toggle(isCustom);
            tabItemOf(this.form.InstanceKey1).toggle(isCustom);
        }

        protected useViewMode() {
            return false;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            if (this.isNew() &&
                !this.form.FieldList.getItems().length) {
                var cols = Q.getColumns("Workflow.WorkflowInstance").filter(x => x.visible == null || x.visible)
                    .map(x => <QueueField>{
                        FieldName: x.name,
                        DisplayName: Q.tryGetText(x.title) ?? x.title ?? x.name,
                        Alignment: x.alignment,
                        DisplayFormat: x.displayFormat,
                        EditLink: x.editLink,
                        EditorType: x.editorType as any,
                        EditorParams: x.editorParams,
                        FormatterType: x.formatterType as any,
                        FormatterParams: x.formatterParams,
                        FormTab: x.tab,
                        FormCategory: x.category,
                        LabelWidthUntilNext: false,
                        LabelWidthJustThis: false,
                        FormWidthUntilNext: false,
                        FormWidthJustThis: false,
                        Updatable: false,
                        IsRequired: x.required,
                        Width: x.widthSet ? x.width : null,
                        MaxLength: x.maxLength,
                        VisibleInGrid: true,
                        VisibleInForm: false,
                        SortOrder: x.sortOrder
                    });

                var items = Q.getForm("Workflow.WorkflowInstance").filter(x =>
                    (x.visible == null || x.visible) &&
                    x.tab == "Details" &&
                    x.name != "Properties" &&
                    x.name &&
                    (isNaN(x.name.substr(1) as any)) &&
                    (!Q.startsWith(x.name, 'Key') || isNaN(x.name.substr(3) as any)) &&
                    (!Q.startsWith(x.name, 'Txt') || isNaN(x.name.substr(3) as any)))
                    .map(x => <QueueField>{
                        FieldName: x.name,
                        DisplayName: Q.tryGetText(x.title) ?? x.title ?? x.name,
                        Alignment: x.alignment,
                        DisplayFormat: x.displayFormat,
                        EditLink: x.editLink,
                        EditorType: x.editorType as any,
                        EditorParams: x.editorParams || {},
                        FormatterType: x.formatterType as any,
                        FormatterParams: x.formatterParams || {},
                        FormTab: x.tab,
                        FormCategory: x.category,
                        FormWidth: x.formCssClass,
                        LabelWidthUntilNext: false,
                        LabelWidthJustThis: false,
                        FormWidthUntilNext: false,
                        FormWidthJustThis: false,
                        IsRequired: x.required,
                        Width: x.widthSet ? x.width : null,
                        MaxLength: x.maxLength,
                        Updatable: false,
                        VisibleInForm: true,
                        VisibleInGrid: Q.any(cols, c => c.FieldName == c)
                    });

                items.splice(0, 0, ...cols.filter(c => c.FieldName == "WorkflowInstanceId"));
                items.splice(1, 0, ...cols.filter(c => c.FieldName == "DurationMs"));

                for (var i = 1; i < cols.length; i++) {
                    var f = cols[i].FieldName;
                    var cs = items.filter(c => c.FieldName == f);
                    for (var x of cs)
                        x.VisibleInGrid = true;
                    items = items.filter(c => c.FieldName != f);
                    items.splice(i, 0, ...cs);
                }

                var d = 0;
                for (var x of items)
                    x.DisplayOrder = ++d;

                for (var col of cols) {
                    var item = Q.tryFirst(items, x => x.FieldName == col.FieldName)
                    if (col.SortOrder) {
                        if (item) {
                            item.SortOrder = col.SortOrder;
                        }
                    }
                }

                this.form.FieldList.value = items;
            }
        }

    }
}